import { render } from "./EditX.vue?vue&type=template&id=1cd7a669&scoped=true"
import script from "./EditX.vue?vue&type=script&lang=js"
export * from "./EditX.vue?vue&type=script&lang=js"

import "./EditX.vue?vue&type=style&index=0&id=1cd7a669&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd7a669"]])

export default __exports__